var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { PluginContainerData } from "./common";
const baseTableData = {};
const TableData = {
  fromJSON(object) {
    const message = __spreadValues({}, baseTableData);
    message.containerData = object.containerData !== void 0 && object.containerData !== null ? PluginContainerData.fromJSON(object.containerData) : void 0;
    message.dimensions = object.dimensions !== void 0 && object.dimensions !== null ? TableData_Dimensions.fromJSON(object.dimensions) : void 0;
    message.header = object.header !== void 0 && object.header !== null ? Boolean(object.header) : void 0;
    message.rowHeader = object.rowHeader !== void 0 && object.rowHeader !== null ? Boolean(object.rowHeader) : void 0;
    message.columnHeader = object.columnHeader !== void 0 && object.columnHeader !== null ? Boolean(object.columnHeader) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.containerData !== void 0 && (obj.containerData = message.containerData ? PluginContainerData.toJSON(message.containerData) : void 0);
    message.dimensions !== void 0 && (obj.dimensions = message.dimensions ? TableData_Dimensions.toJSON(message.dimensions) : void 0);
    message.header !== void 0 && (obj.header = message.header);
    message.rowHeader !== void 0 && (obj.rowHeader = message.rowHeader);
    message.columnHeader !== void 0 && (obj.columnHeader = message.columnHeader);
    return obj;
  }
};
const baseTableData_Dimensions = { colsWidthRatio: 0, rowsHeight: 0, colsMinWidth: 0 };
const TableData_Dimensions = {
  fromJSON(object) {
    var _a, _b, _c;
    const message = __spreadValues({}, baseTableData_Dimensions);
    message.colsWidthRatio = ((_a = object.colsWidthRatio) != null ? _a : []).map((e) => Number(e));
    message.rowsHeight = ((_b = object.rowsHeight) != null ? _b : []).map((e) => Number(e));
    message.colsMinWidth = ((_c = object.colsMinWidth) != null ? _c : []).map((e) => Number(e));
    return message;
  },
  toJSON(message) {
    const obj = {};
    if (message.colsWidthRatio) {
      obj.colsWidthRatio = message.colsWidthRatio.map((e) => Math.round(e));
    } else {
      obj.colsWidthRatio = [];
    }
    if (message.rowsHeight) {
      obj.rowsHeight = message.rowsHeight.map((e) => Math.round(e));
    } else {
      obj.rowsHeight = [];
    }
    if (message.colsMinWidth) {
      obj.colsMinWidth = message.colsMinWidth.map((e) => Math.round(e));
    } else {
      obj.colsMinWidth = [];
    }
    return obj;
  }
};
export {
  TableData,
  TableData_Dimensions
};
//# sourceMappingURL=plugin_table.js.map
